import React, { useEffect, useState } from 'react'
import '../styles/EventScheduler.css'
import { Row, Col, Popover, message } from 'antd'
import EventSchedulerItem from './EventSchedulerItem';
import { PlusCircleFilled } from '@ant-design/icons'
import { connect } from 'react-redux';
import { requestServerPost, requestServerGet, selectPage } from '../actions';

function EventScheduler(props) {

    const [schedules, setSchedules] = useState([]);
    const { data, onSaved = () => { } } = props;
    const { EventSchedules } = data;

    var defaultData = {
        EventScheduleID: -1,
        EventPlaylistID: -1,
        WeekDay: "0,1,2,3,4,5,6",
        StartTime: "",
        EndTime: "",
        StartDate: "",
        EndDate: ""
    }

    const createEventSchedule = (scheduledata) => {
        const { requestServerPost, usertoken } = props;


        const params = new FormData();
        const { EventPlaylistID } = data;
        const { WeekDay, StartTime, EndTime, StartDate, EndDate } = scheduledata;

        params.append("eventplaylistid", EventPlaylistID)
        params.append("weekday", WeekDay)
        params.append("starttime", StartTime)
        params.append("endtime", EndTime)
        params.append("startdate", StartDate)
        params.append("enddate", EndDate)


        requestServerPost("create_eventschedule", params, { }, (response) => {
            reloadTimelineSchedules();
        }, usertoken);
    }
    const deleteTimelineSchedule = (scheduledata) => {
        const { requestServerPost, usertoken } = props;
        const params = new FormData();
        const { EventScheduleID } = scheduledata;

        params.append("eventscheduleid", EventScheduleID)

        requestServerPost("delete_eventschedule", params, { }, (response) => {
            reloadTimelineSchedules();
        }, usertoken);
    }

    const reloadTimelineSchedules = () => {
        const { requestServerGet, usertoken } = props;

        const { EventPlaylistID } = data;

        requestServerGet("get_eventschedules", { eventplaylistid: EventPlaylistID }, {}, (response) => {
            setSchedules(response.data)
        }, usertoken);
    }

    useEffect(() => {
        setSchedules(EventSchedules)
    }, [])

    useEffect(() => {
        // console.log(JSON.stringify(schedules))
    }, [schedules])

    return (
        <div className="scheduler">
            <div className="itemgroup">
                <div>
                    {schedules.map((weekdaySchedule, index) => (
                        <EventSchedulerItem key={`${weekdaySchedule.EventScheduleID}_${index}`} data={weekdaySchedule} onSaved={onSaved} onRemove={(e) => {
                            if (schedules.length > 1) {
                                deleteTimelineSchedule(weekdaySchedule)
                            }
                            else {
                                // deleteTimelineSchedule(weekdaySchedule)
                                message.warn("You must have at least one schedule item")
                                e.preventDefault();
                            }

                        }
                        }></EventSchedulerItem>
                    ))}
                </div>
                <div onClick={(e) => {
                    // console.log("add schedules " + schedules.length)
                    const sch = [...schedules]

                    createEventSchedule(defaultData)
                    e.preventDefault();
                }} className="btn-plus-item">
                    <PlusCircleFilled style={{ color: "rgb(221, 221, 221)", cursor: "pointer", fontSize: "20px" }} />
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return { userdata: state.userdata, usertoken: state.usertoken, selectedBrandData: state.selectedBrandData };
}

export default connect(mapStateToProps, { requestServerGet, requestServerPost, selectPage })(EventScheduler);
